import { render, staticRenderFns } from "./DoorHasWindows.vue?vue&type=template&id=3d37c8cb&scoped=true"
import script from "./DoorHasWindows.vue?vue&type=script&lang=ts"
export * from "./DoorHasWindows.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d37c8cb",
  null
  
)

export default component.exports